import React from "react";
import "./InfoDetails.css";
import { Link } from "react-router-dom";

const InfoReports = () => {
  return (
    <div className="info-detail">
      <div className="info-hero reports">
        <h2>Módulo de reportes</h2>
        <p>
          Genera y descarga reportes personalizados para el análisis detallado
          de consumos y facturación.
        </p>
      </div>

      <section className="info-section">
        <h3>Reportes disponibles</h3>
        <ul>
          <li>Detalle de facturas cargadas.</li>
          <li>Consumos de potencia/energía con alertas de anomalías.</li>
          <li>Prorrateo de energía, agua y gas.</li>
        </ul>
      </section>

      <section className="info-section alt">
        <h3>Finalidad</h3>
        <p>
          Proveer herramientas de análisis avanzadas para una mejor toma de
          decisiones.
        </p>
      </section>

      <section className="info-flow">
        <h3>Flujo de generación de reportes</h3>
        <ol>
            <li>El usuario accede al <b>módulo de reportes</b>.</li>
            <li>Selecciona el tipo de reporte: facturas, consumos, prorrateo.</li>
            <li>Configura filtros de <b>rango de fechas</b> y <b>planta</b>.</li>
            <li>El sistema genera el <b>archivo PDF o Excel</b> en segundos.</li>
            <li>Se inicia la descarga del reporte para análisis o distribución.</li>
        </ol>
      </section>


      <div className="info-cta">
        <h4>¿Querés generar reportes?</h4>
        <Link to="/reports" className="cta-button">
          Ver reportes
        </Link>
      </div>
    </div>
  );
};

export default InfoReports;
